import {supabase} from '../supabase/supabase';

export const fetchStripeTaxMappings=async()=>{
  const {data,error}=await supabase.rpc(
    'admin_get_stripe_tax_mappings_1793006000000'
  );

  if (error) throw error;

  return data || [];
};

export const fetchAdminCategories=async()=>{
  const {data,error}=await supabase
    .from('categories')
    .select('id,name,slug,icon_name,stripe_product_tax_code')
    .order('name');

  if (error) throw error;

  return data || [];
};

export const saveStripeTaxMapping=async(values)=>{
  const {data,error}=await supabase.rpc(
    'admin_upsert_stripe_tax_mapping_1793006000000',
    {
      p_category_key:values.category_key,
      p_category_name:values.category_name,
      p_stripe_product_tax_code:values.stripe_product_tax_code,
      p_active:values.active
    }
  );

  if (error) throw error;

  return data;
};

export const saveAdminCategory=async(values)=>{
  const {data,error}=await supabase.rpc(
    'admin_upsert_category_with_tax_code_1793007000000',
    {
      p_category_id:values.id || null,
      p_category_name:values.name,
      p_category_slug:values.slug,
      p_category_icon:values.icon_name || 'Box',
      p_stripe_product_tax_code:values.stripe_product_tax_code || null
    }
  );

  if (error) throw error;

  return data;
};